(function($) {

    $.fn.equalWidths = function() {
        var maxWidth = 0,
            $this = $(this);

        $this.each( function() {

            var width = $(this).outerWidth();

            if ( width > maxWidth ) { maxWidth = width; }

        });

        return $this.css('width', maxWidth).addClass('equalWidths');
    };

})(jQuery);